import React from "react";
import { inject, observer } from "mobx-react";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "Stores/Management/types";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { Formik, FormikProps, FormikActions } from "formik";
import * as Yup from "yup";
import FileField from "./FileField/FileField";
import { IFile } from "@src/Interfaces/Entity/File";
import { Person, PersonProfileImage } from "@src/Interfaces/Entity/Person";
import { STFormContentWrapper, CSTFormWrapper } from "./styles";

interface IProps {
  auth?: IAuthStore;
  values?: IValuesStore;
  management?: IManagementStore;
}

export interface IState {
  isLoading: boolean;
  person?: Person;
}

export interface IProfileImageForm {
  imageUrl: string;
  fileImage: File;
}

const FIVE_MB = 5e6;

const profileImageVaidationSchema = Yup.object().shape({  
  fileImage: Yup.mixed().test(
    "maxSize",
    () => Values.getLocalizationValue("maxSize"),
    value => value.size < FIVE_MB
  ),
});

@inject("auth", "values", "management")
@observer
export default class ProfileImage extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: true
    };
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    document.title = Values.getLocalizationValue("profileImage");
    let person = await this.props.management.getPerson(this.props.auth.user.person.id);
    this.setState({ person: person, isLoading: false });
  }

  handleSubmit = async (values: IProfileImageForm, actions: FormikActions<IProfileImageForm>) => {
    let result: PersonProfileImage = {};
    if (values.fileImage.name === "reset") {
      result.image = this.props.values.common.EmptyId;
    } else if (values.fileImage.name !== "default") {
      const file: IFile = await this.props.management.uploadFile(
        values.fileImage,
        this.props.auth.user.person.id,
        this.props.values.fileTypes.ProfileImage
      );
      result.image = file.id;
    }
    if (values.fileImage.name !== "default") {
      await this.props.management.saveProfileImage(result);
    }
  };  

  render() {
    if (this.state.isLoading) {
      return null;
    }

    const initialValues: IProfileImageForm = {
      imageUrl: this.state.person.profileImageUrl,
      fileImage: new File([], "default")
    };

    return (
      <Grid container justify="center" alignItems="center">
        <STFormContentWrapper>
          <STPageHeader>
            {Values.getLocalizationValue("profileImage")}
          </STPageHeader>

          <Formik
            initialValues={initialValues}
            validationSchema={profileImageVaidationSchema}
            onSubmit={this.handleSubmit}
            render={(formikProps: FormikProps<IProfileImageForm>) => (
              <CSTFormWrapper onSubmit={formikProps.handleSubmit}>

                <FileField<IProfileImageForm>
                  fieldName="fileImage"
                  formikProps={formikProps}
                  imageUrl={initialValues.imageUrl}
                />

              </CSTFormWrapper>
            )}
          />
        </STFormContentWrapper>
      </Grid>
    );
  }
}
